import { createUserManager } from 'redux-oidc'
import { getConfigSection } from '../config'

const oidc = getConfigSection('oidc')
const port = window.location.port

const userManagerConfig = {
    ...oidc,
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}/oidc-callback`,
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}/silent_renew.html`,
    automaticSilentRenew: true,
    filterProtocolClaims: true
}

const userManager = createUserManager(userManagerConfig)

export default userManager
